import React from 'react';
import { InputLabel } from '@mui/material';
import {
  Controller, useController, Path, PathValue, FieldValues,
} from 'react-hook-form';
import { PatternFormat } from 'react-number-format';
import { twMerge } from 'tailwind-merge';
import ElementUtils from '../utils';
import { InputProps } from '.';
import { CommonReactHookFormProps } from '../types';

interface RHFInputProps<T,
  Value, FormFields extends FieldValues,
> extends InputProps<T, Value>, CommonReactHookFormProps<FormFields> { }

function RHFPhoneInput<T, Value, FormFields extends FieldValues>(
  props: RHFInputProps<T, Value, FormFields>,
) {
  const {
    name,
    control,
    value,
    label,
    disabled,
    helperText,
  } = props;

  const {
    fieldState: { error },
  } = useController<FormFields>({
    name,
    control,
    rules: { required: true },
    defaultValue: value as PathValue<FormFields, Path<FormFields>> | undefined,
  });

  return (
    <Controller
      control={control}
      name={name}
      render={({ field }) => (
        <div className="relative flex items-start justify-center flex-col">
          <InputLabel className={twMerge('flex font-bold text-[#28364C]')} error={!!error}>
            {label}
          </InputLabel>
          <PatternFormat
            {...field}
            format="(###) ### ####"
            placeholder={helperText}
            onValueChange={(values: any) => {
              field.onChange(values.value);
            }}
            className=" outline outline-[1px] outline-error placeholder-secondary/60 placeholder:text-sm border-0  bg-transparent h-[1.4375em] m-0 block min-w-0 py-[18px] px-[14px] w-full bg-white custom-shadow rounded-md mt-2 outline-none border-none"
            style={
              {
                outline: error ? 'solid' : 'none',
                outlineWidth: error ? '1px' : '0px',
                outlineColor: error ? 'red' : '',
              }
            }
            disabled={disabled}
          />
          {error && (
            <div className="absolute -bottom-5 text-error text-xs">
              {ElementUtils.renderError(error)}
            </div>
          )}
        </div>
      )}
    />
  );
}

export default RHFPhoneInput;
